import { createRouter, createWebHistory } from 'vue-router';

import homeView from '@/views/HomePageView.vue';
import NotFound from '@/views/NotFoundView.vue';
import LoginView from '@/views/LoginView.vue';
import RegisterView from '@/views/RegisterView.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import IndexView from '@/views/Dashboard/IndexView.vue';
import CourseView from '@/views/Dashboard/CourseView.vue';
import AdminIndexView from '@/views/Admin/IndexView.vue';
import LoadingView from '@/views/LoadingView.vue';
import authUserService from '@/services/AuthUserService';
import MaintanceView from '@/views/MaintanceView.vue';
import PublicCourseView from '@/views/PublicCourseView.vue';
import CartView from '@/views/AuthenticatedViews/cartView.vue';
import PaymentInformationView from '@/views/PaymentInformationView.vue';
import { env } from '@/composables/config';
import PurchaseView from '@/views/PurchaseView.vue';
import { useAuthStore } from "@/stores/auth";
import { useContextStore } from '@/stores/context';
import ProfileView from '@/views/ProfileView.vue';
import LanguageService from '@/services/LanguageService';
import EmailVerifyView from '@/views/EmailVerifyView.vue';
import SearchPageView from '@/views/SearchPageView.vue';
import PaymentHistoryView from '@/views/Dashboard/PaymentHistoryView.vue';
import PaymentInvoiceView from '@/views/Dashboard/PaymentInvoiceView.vue';
import CourseCertificateView from '@/views/CourseCertificateView.vue';
import InstructorView from '@/views/Admin/InstructorView.vue';
import TestimonyView from '@/views/Admin/TestimonyView.vue';
import ManageStudentsView from '@/views/Admin/ManageStudentsView.vue';
import BlogManagementView from '@/views/Admin/BlogManagementView.vue';
import BlogPostDetailView from '@/views/BlogPostDetailView.vue';
import BlogPageView from '@/views/BlogPageView.vue';
import BlogLayout from '@/layouts/BlogLayout.vue';
import AboutView from '@/views/Admin/AboutView.vue';
import ContractGenerationView from '@/views/Admin/ContractGenerationView.vue';
import DashLayout from '@/layouts/DashLayout.vue';
import CategoryIndexView from '@/views/Admin/CategoryIndexView.vue';
import MaterialManagementView from '@/views/Admin/MaterialManagementView.vue';
import StudentMaterialsView from '@/views/Dashboard/StudentMaterialsView.vue';
import SupportView from '@/views/Dashboard/SupportView.vue';
import AdminSupportView from '@/views/Admin/AdminSupportView.vue';
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue';
import TermsPolicyView from '@/views/TermsPolicyView.vue';
import LogoView from '@/views/LogoView.vue';
import ForgotPasswordView from '@/views/ForgotPasswordView.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import PurchasedMaterialsView from '@/views/Dashboard/PurchasedMaterialsView.vue';
import MaterialSellingMaterial from '@/views/Admin/MaterialSellingMaterial.vue';
import MaterialsForTeachersView from '@/views/MaterialsForTeachersView.vue';
import SellingMaterialGroupProductView from '@/views/SellingMaterialGroupProductView.vue';

const routes = [
    {
        path: "/",
        name: "public",
        component: BlogLayout,
        redirect: "/",
        children: [
            {
                path: '',
                name: 'Home',
                component: homeView
            },
            {
                path: 'course/:uuid',
                name: 'PublicCourseView',
                component: PublicCourseView
            },
            {
                path: 'cart',
                name: 'CartView',
                component: CartView
            },
            {
                path: 'purchase',
                name: 'PurchaseView',
                component: PurchaseView
            },
            {
                path: 'search',
                name: 'SearchPageView',
                component: SearchPageView
            },
            {
                path: 'privacy-policy',
                name: 'PrivacyPolicyView',
                component: PrivacyPolicyView
            },
            {
                path: 'terms-policy',
                name: 'TermsPolicyView',
                component: TermsPolicyView
            },
            {
                path: 'material-for-teachers',
                name: 'MaterialForTeachersView',
                component: MaterialsForTeachersView
            },
            {
                path: 'teacher-material/:id',
                name: 'SellingMaterialGroupProductView',
                component: SellingMaterialGroupProductView
            },
        ]
    },
    {
        path: "/blog",
        name: "blog_routes",
        component: BlogLayout,
        redirect: "/",
        children: [
            {
                path: 'home',
                name: 'BlogPage',
                component: BlogPageView
            },
            {
                path: 'detail/:id',
                name: 'BlogPostDetail',
                component: BlogPostDetailView
            }
        ]
    },
    {
        path: "/",
        name: "auth",
        component: AuthLayout,
        redirect: "/auth/login",
        children: [
            {
                path: 'login',
                name: 'Login',
                component: LoginView
            },
            {
                path: 'register',
                name: 'Register',
                component: RegisterView
            }
        ]
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: DashLayout,
        redirect: "/dashboard",
        children: [
            {
                path: '',
                name: 'UserDashboard',
                component: IndexView
            },
            {
                path: 'course/:uuid',
                name: 'MyCourse',
                component: CourseView
            },
            {
                path: 'payment/info',
                name: 'PaymentInformationView',
                component: PaymentInformationView
            },
            {
                path: 'profile',
                name: 'ProfileView',
                component: ProfileView
            },
            {
                path: 'payment_history',
                name: 'PaymentHistory',
                component: PaymentHistoryView
            },
            {
                path: 'payment_invoice/:id',
                name: 'PaymentInvoice',
                component: PaymentInvoiceView
            },
            {
                path: 'materials/',
                name: 'StudentMaterialView',
                component: StudentMaterialsView
            },
            {
                path: 'support/',
                name: 'UserSupportView',
                component: SupportView
            },
            {
                path: 'certificate/:uuid',
                name: 'CourseCertificateView',
                component: CourseCertificateView
            },
            {
                path: 'teacher_materials/',
                name: 'PurchasedMaterialsView',
                component: PurchasedMaterialsView
            }
        ]
    },
    {
        path: "/admin",
        name: "admin",
        component: DashLayout,
        redirect: "/admin/dashboard",
        children: [
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                component: AdminIndexView
            },
            {
                path: 'instructors',
                name: 'InstructorView',
                component: InstructorView
            },
            {
                path: 'about',
                name: 'AboutView',
                component: AboutView
            },
            {
                path: 'testimonies',
                name: 'TestimoyView',
                component: TestimonyView
            },
            {
                path: 'students',
                name: 'ManageStudentView',
                component: ManageStudentsView
            },
            {
                path: 'blog',
                name: 'ManageBlogView',
                component: BlogManagementView
            },
            {
                path: 'contract',
                name: 'ContractGenerationView',
                component: ContractGenerationView
            },
            {
                path: 'categories',
                name: 'CategoriesView',
                component: CategoryIndexView
            },
            {
                path: 'exclusive_material',
                name: 'ManageExclusiveMaterials',
                component: MaterialManagementView
            },
            {
                path: 'support/',
                name: 'AdminSupportView',
                component: AdminSupportView
            },
            {
                path: 'selling_material',
                name: 'ManageSellingMaterial',
                component: MaterialSellingMaterial
            }
        ]
    },
    {
        path: '/logo',
        name: 'Logo',
        component: LogoView
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: ForgotPasswordView
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/email/verify',
        name: 'EmailVerify',
        component: EmailVerifyView
    },
    {
        path: '/loading',
        name: 'Loading',
        component: LoadingView
    },
    {
        path: '/maintance',
        name: 'Maintance',
        component: MaintanceView
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

/**
 * Middleware to check auth routes
 */
router.beforeEach(async (to, from, next) => {
    if (['true', true].includes(process.env.VUE_APP_ON_MAINTANCE) && to.path !== '/maintance') {
        return next('/maintance');
    }

    if (env('APP_PRODUCTION')) {
        // ipHandler.detectIp();
    }

    LanguageService.getLanguages();

    const authUser = useAuthStore();
    const contextStore = useContextStore();

    if (to.path !== '/loading' && to.path !== '/login') {
        contextStore.saveRequestedRoute(to.path, JSON.parse(JSON.stringify(to.query)));
    }

    if (to.path.startsWith('/dashboard') || to.path.startsWith('/admin')) {
        if (authUser.isAuthenticated) {
            return next();
        }

        try {
            await authUserService.attemptLogin();
        } catch (e) {
            // 
        }

        if (authUser.isAuthenticated) {
            return next();
        }

        return next('/loading');
    }

    if (to.path !== '/loading') {
        authUserService.attemptLogin().catch(() => {});
    }

    return next();
});

export default router;
